import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import Logo from "@/components/Logo";
import ShareMenu from "@/components/ShareMenu";
import { Loader2, Heart, ArrowRight } from "lucide-react";

const TYPE_LABEL = { rally: "Rally of the Day", friend: "Player Milestone", achievement: "Achievement", training: "Training", post: "Player Post" };

export default function PostShare() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    http.get(`/social/highlights/${id}`).then((r) => setItem(r.data)).catch(() => setErr(true));
  }, [id]);

  return (
    <div className="min-h-screen pv-bg-neutral">
      <header className="pv-bg-dark text-white">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
          <Logo light />
          <button data-testid="share-open-app" onClick={() => navigate("/home")} className="text-sm font-bold pv-text-primary inline-flex items-center gap-1 hover:opacity-80">Open PaddleVerse <ArrowRight size={15} /></button>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-8">
        {err ? (
          <div className="text-center py-20" data-testid="post-not-found">
            <p className="text-lg font-bold pv-text-dark">This post isn't available.</p>
            <button onClick={() => navigate("/home")} className="mt-4 bg-[#BED445] text-black font-extrabold rounded-full px-6 py-2.5 text-sm">Explore PaddleVerse</button>
          </div>
        ) : !item ? (
          <div className="grid place-items-center py-24"><Loader2 className="animate-spin pv-text-dark" size={28} /></div>
        ) : (
          <div className="rounded-3xl bg-white border border-[#0E395F]/10 shadow-sm overflow-hidden" data-testid="post-share-card">
            {item.thumbnail && <div className="h-72 bg-cover bg-center" style={{ backgroundImage: `url(${item.thumbnail})` }} />}
            <div className="p-6">
              <span className="text-[10px] font-black uppercase tracking-wider text-[#F5B700]">{TYPE_LABEL[item.type] || "PaddleVerse"}</span>
              <h1 className="text-2xl font-black font-display pv-text-dark mt-1">{item.title}</h1>
              <p className="text-[#5C7285] mt-1">{item.subtitle}</p>
              <div className="flex items-center gap-4 mt-4 pt-4 border-t border-black/5">
                <span className="inline-flex items-center gap-1.5 text-sm font-bold text-[#F5B700]"><Heart size={16} fill="currentColor" />{item.reactions}</span>
                <ShareMenu item={item} />
              </div>
            </div>
          </div>
        )}
        <p className="text-center text-xs text-[#5C7285] mt-8">The PaddleVerse — the all-in-one platform for competitive pickleball players.</p>
      </main>
    </div>
  );
}
